<template>
  <form class="p-3" @submit.prevent="handleSubmit">
    <b-row v-if="!selectedData">
      <!-- <b-col md="12" class="mb-3">
        <label class="mb-1">Creator <span class="text-danger">*</span></label>
        <v-select
          :options="listUsers"
          v-model="dataForm.employee_id"
          label="name"
          :reduce="(option) => option?.id"
        >
          <template #option="option">
            <UserOptionTemplate :option="option" />
          </template>
          <template #selected-option="option">
            <UserOptionTemplate :option="option" />
          </template>
        </v-select>
      </b-col> -->
      <b-col md="6" class="mb-3">
        <label class="mb-1">
          Fleet
          <span class="text-danger">*</span>
        </label>
        <v-select
          :options="fleetOptions"
          v-model="dataForm.vehicleId"
          label="name"
          :reduce="(option) => option?.id"
          @input="fetchVehiclePowerList"
        ></v-select>
      </b-col>
      <b-col md="6">
        <label class="mb-1">
          Effective Date
          <span class="text-danger">*</span>
        </label>
        <date-picker
          type="date"
          placeholder="Select time"
          format="DD-MM-YYYY"
          value-type="DD-MM-YYYY"
          v-model="dataForm.effectiveDate"
          :disabled-date="disableAfterToday"
          class="w-100"
        ></date-picker>
      </b-col>
      <b-col md="12" class="mb-3">
        <label class="mb-1">Description</label>
        <b-textarea v-model="dataForm.description" />
      </b-col>
    </b-row>
    <b-row v-else class="mb-3">
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Fleet Name
      </b-col>
      <b-col md="8" style="color: black">
        <b-badge variant="success">
          {{ selectedData?.vehicle?.name ?? '-' }}
        </b-badge>
      </b-col>
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Transaction Type
      </b-col>
      <b-col md="8" style="color: black">Adjustment</b-col>
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Request Date
      </b-col>
      <b-col md="8" style="color: black">
        {{
          selectedData?.created_at ? formateDate(selectedData?.created_at) : '-'
        }}
      </b-col>
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Effective Date
      </b-col>
      <b-col md="8" style="color: black">
        {{
          selectedData?.effective_date
            ? formateDate(selectedData?.effective_date)
            : '-'
        }}
      </b-col>
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Creator
      </b-col>
      <b-col md="8" style="color: black" class="mb-2">
        {{ selectedData?.user?.requestor?.name ?? '-' }}
      </b-col>
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Description
      </b-col>
      <b-col md="8" style="color: black">
        {{ selectedData?.description ?? '-' }}
      </b-col>
    </b-row>
    <table class="w-100 table-striped">
      <thead>
        <th>ENGINE NAME</th>
        <th>CURRENT TOTAL</th>
        <th v-if="!selectedData">HOURS</th>
        <!-- <th v-if="!selectedData">MINUTES</th> -->
        <th v-if="selectedData">Transaction</th>
        <th>TO BE TOTAL</th>
      </thead>
      <tbody v-if="loading">
        <tr>
          <td colspan="5" class="text-center">
            <b-spinner small></b-spinner>
            Loading...
          </td>
        </tr>
      </tbody>

      <tbody v-else-if="dataForm.runningHours && dataForm.runningHours.length">
        <template v-for="(item, i) in dataForm.runningHours">
          <tr :key="i">
            <td>
              <div>
                <strong>{{ item.powerType }}</strong>
                <br />
                <small>-</small>
              </div>
            </td>
            <td v-if="!selectedData">{{ toHourMinute(item?.totalMinutes) }}</td>
            <td v-else>
              {{
                toHourMinute(
                  (item?.totalRunningHour || 0) - (item?.running_minutes || 0)
                )
              }}
            </td>
            <td v-if="!selectedData" style="width: 100px" class="d-flex px-2">
              <div style="width: 134px">
                <InputCurrency
                  placeholder="00"
                  class="mr-1 text-right bg-white"
                  v-model="item.hour"
                  prepend=""
                />
              </div>
            </td>
            <!-- <td class="px-2" v-if="!selectedData">
              <b-form-input
                placeholder="00"
                style="width: 80px"
                class="mr-1 text-center bg-white"
                v-model="item.min"
              />
            </td> -->
            <td v-if="selectedData">
              {{ toHourMinute(item.running_minutes) }}
            </td>
            <td v-if="!selectedData">
              {{
                toHourMinute(
                  toMinutes(item.hour || 0, item.min || 0) +
                    item.totalMinutes || 0
                )
              }}
            </td>
            <td v-else>
              {{ toHourMinute(item.totalRunningHour || 0) }}
            </td>
          </tr>
        </template>
      </tbody>

      <tbody v-else>
        <tr>
          <td colspan="5" class="text-center">Not Found Running History</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex mt-4" v-if="!selectedData">
      <b-button
        variant="outline-primary"
        class="w-50 mr-3"
        type="button"
        @click="$emit('close')"
      >
        Cancel
      </b-button>
      <b-button
        v-if="!loadingSubmit"
        variant="primary"
        type="submit"
        class="w-50"
      >
        Submit
      </b-button>
      <b-button
        variant="primary"
        v-else
        class="w-50 d-flex align-items-center justify-content-center"
        disabled
      >
        <b-spinner small class="mr-1"></b-spinner>
        Saving...
      </b-button>
    </div>
    <div v-else>
      <b-button
        variant="outline-primary"
        class="w-100 mt-3"
        type="button"
        @click="$emit('close')"
      >
        Close
      </b-button>
    </div>
  </form>
</template>

<script>
import UserOptionTemplate from '@/src/components/global/Partial/UserOptionTemplate.vue'
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
  usersActions,
} from '@/src/Utils/helper'
import UserTemplate from '@/src/components/global/Partial/UserTemplate.vue'
import moment from '@/node_modules/moment/moment'
import { numberFormat } from '@/src/plugins/helpers'
import InputCurrency from '@/src/components/global/InputCurrency.vue'

export default {
  name: 'FormAdjustmentRunningHours',
  components: { UserOptionTemplate, UserTemplate, InputCurrency },
  props: {
    selectedData: null,
  },
  data() {
    return {
      loading: false,
      loadingSubmit: false,
      fleetOptions: [],
      listUsers: [],
      userDetail: {
        name: '',
        photo: '',
      },
      dataForm: {
        employee_id: null,
        vehicleId: null,
        effectiveDate: '',
        remark: '',
        runningHours: [],
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...usersActions,
    ...maintenanceActions,
    ...pmsActions,
    disableAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // biar hanya tanggal yang dihitung
      return date > today // disable jika lebih besar dari hari ini
    },
    async fetchFleets() {
      try {
        let params = {
          page: 1,
          perPage: 9999,
          showAll: true,
          active: true,
        }

        let res = await this.getFleets(params)

        if (res.status) {
          if (res.data && res.data.length > 0) {
            this.fleetOptions = res.data.map((val) => ({
              ...val,
              text: val.name,
              value: val.id,
            }))
            this.fleetFilteredOptions = this.fleetOptions
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchUsers() {
      try {
        let res = await this.getUsers({
          page: 1,
          showAll: true,
          perPage: 10000,
        })
        this.listUsers = res.data.data
          ? res.data.data.map((user) => {
              return {
                ...user,
                id: user.id,
                name: user.userDetail?.name,
              }
            })
          : []
      } catch (error) {
        console.log(error)
      }
    },

    async fetchVehiclePowerList() {
      this.loading = true
      try {
        if (this.dataForm.vehicleId) {
          const res = await this.getVehiclePowerListV3(this.dataForm.vehicleId)
          const { data } = res?.data
          this.dataForm.runningHours = data.map((rh) => ({
            vehiclePowerId: rh.id,
            powerSeriesId: rh.power_series.id,
            powerTypeId: rh.power_type.id,
            totalMinutes: rh.total_running_hour * 60,
            powerType: rh.power_type.name,
            min: null,
            hour: null,
          }))
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },

    async handleSubmit() {
      try {
        if (!this.dataForm.vehicleId || !this.dataForm.effectiveDate) {
          this.$swal(
            'Warning',
            'Vehicle or Effective Date Required.',
            'warning'
          )
          return false
        }
        this.loadingSubmit = true
        const body = {
          ...this.dataForm,
          remark: this.dataForm.description,
          effectiveDate: moment(
            this.dataForm.effectiveDate,
            'DD-MM-YYYY'
          ).format('YYYY-MM-DD'),
          state: 'completed',
          runningHours: this.dataForm?.runningHours?.map((item) => ({
            vehicle_power_id: item?.vehiclePowerId,
            power_type_id: item?.vehicleTypeId,
            power_series_id: item?.vehicleTypeId,
            running_hours_day: Number(item?.hour),
            running_minutes: this.toMinutes(item?.hour, item?.min),
            totalRunningHour: item.totalMinutes + item.hour * 60,
            powerType: item.powerType,
          })),
        }

        const res = await this.createAdjustmentRhV3({
          data: body,
          vehicleId: this.dataForm?.vehicleId,
        })

        if (res.status == 'success') {
          this.$swal(
            'Success',
            res?.data?.message ?? 'Success Save Running Hours',
            'success'
          ).then((result) => {
            if (result.isConfirmed) {
              this.$emit('close')
            }
          })
          this.$emit('refetch')
        } else {
          this.$swal(
            'Error',
            res?.data?.message || 'Failed Save Running Hours',
            'error'
          )
        }
        this.loadingSubmit = false
      } catch (error) {
        console.log(error)
        this.$swal('Error', 'Failed System Error', 'error')
      } finally {
        this.loadingSubmit = false
      }
    },

    handleCheckAll(e) {
      const { checked } = e.target
      this.dataForm.forEach((item) => {
        item.checked = checked
      })
    },
    toMinutes(hour, minutes) {
      return Number(hour) * 60 + Number(minutes)
    },
    toHourMinute(totalMinutes) {
      // const duration = moment.duration(totalMinutes, 'minutes')
      // const hours = Math.floor(duration.asHours())
      // const minutes = duration.minutes()
      const hours = numberFormat(Math.floor(totalMinutes / 60))
      return `${hours} Hours`
    },
    formateDate(date) {
      return moment(date).format('DD MMM YYYY')
    },
  },
  mounted() {
    this.fetchFleets()
    this.fetchUsers()
    if (this.selectedData) {
      this.dataForm.runningHours = this.selectedData?.metadata
      this.dataForm.remark = this.selectedData?.description
    }
  },
}
</script>
<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
.font-semibold {
  font-weight: 600;
}
</style>
